import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Manual } from './Manual';
import { MonthlyReport } from './MonthlyReport';
import './styles.css';

const path = window.location.pathname.replace(/\/$/, '');
const RootView = path === '/manual' ? Manual : path === '/monthly-report' ? MonthlyReport : App;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootView />
  </StrictMode>
);
